document.addEventListener('DOMContentLoaded', function () {
  const collapseRoot = document.querySelector('.ja-productpage-collapse');
  if (!collapseRoot) return;

  const raf2 = (cb) => requestAnimationFrame(() => requestAnimationFrame(cb));

  const setMaxHeight = (element) => {
    if (!element) return;
    const h = element.scrollHeight + 20;
    raf2(() => { element.style.maxHeight = h + 'px'; });
  };

  let roTimeout;
  const ro = new ResizeObserver((entries) => {
    clearTimeout(roTimeout);
    roTimeout = setTimeout(() => {
      for (const entry of entries) {
        const desc = entry.target.closest('.ja-productpage-collapse-item__desc');
        if (desc && desc.parentElement.classList.contains('show') && getComputedStyle(desc).maxHeight !== 'none') {
          setMaxHeight(desc);
        }
      }
    }, 80);
  });

  function unlock(desc) {
    desc.addEventListener('transitionend', function h(e) {
      if (e.propertyName !== 'max-height') return;
      desc.removeEventListener('transitionend', h);
      desc.style.maxHeight = 'none';
    }, { once: true });
  }

  // Accordion
  collapseRoot.addEventListener('click', (e) => {
    const header = e.target.closest('.ja-productpage-collapse-item-header');
    if (!header) return;

    const currentItem = header.parentElement;
    const desc = currentItem.querySelector('.ja-productpage-collapse-item__desc');
    if (!desc) return;

    const isOpen = currentItem.classList.contains('show');

    collapseRoot.querySelectorAll('.ja-productpage-collapse-item.show').forEach((item) => {
      if (item !== currentItem) {
        item.classList.remove('show');
        const otherDesc = item.querySelector('.ja-productpage-collapse-item__desc');
        if (getComputedStyle(otherDesc).maxHeight === 'none') {
          otherDesc.style.maxHeight = otherDesc.scrollHeight + 'px';
        }
        requestAnimationFrame(() => { otherDesc.style.maxHeight = '0px'; });
      }
    });

    if (isOpen) {
      currentItem.classList.remove('show');
      if (getComputedStyle(desc).maxHeight === 'none') {
        desc.style.maxHeight = desc.scrollHeight + 'px';
      }
      requestAnimationFrame(() => { desc.style.maxHeight = '0px'; });
    } else {
      currentItem.classList.add('show');
      setMaxHeight(desc);
      unlock(desc);
    }
  });

  // Read More
  const initReadMore = (container) => {
    const content = container.querySelector('[data-collapsible-content]');
    const button = container.querySelector('[data-collapsible-toggle]');
    const toggleWrapper = container.querySelector('.collapsible-content-toggle');
    const threshold = 120;

    if (!content || !button || !toggleWrapper) return;

    const checkHeight = () => {
      const isOverflowing = content.scrollHeight > threshold;
      container.classList.toggle('is-truncatable', isOverflowing);

      if (!isOverflowing) {
        content.classList.remove('is-collapsed');
      } else if (!container.dataset.readMoreInitialized) {
        content.classList.add('is-collapsed');
      }
      
      const desc = container.closest('.ja-productpage-collapse-item__desc');
      if (desc && desc.parentElement.classList.contains('show')) {
        const wasNone = getComputedStyle(desc).maxHeight === 'none';
        if (wasNone) { desc.style.maxHeight = desc.scrollHeight + 'px'; }
        raf2(() => setMaxHeight(desc));
        if (wasNone) { unlock(desc); }
      }
    };

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const collapsed = content.classList.toggle('is-collapsed');
      
      const from = content.getBoundingClientRect().height;
      const to = collapsed ? 114 : content.scrollHeight;
      content.style.maxHeight = from + 'px';
      requestAnimationFrame(() => { content.style.maxHeight = to + 'px'; });
      
      content.addEventListener('transitionend', function h(ev) {
        if (ev.propertyName !== 'max-height') return;
        content.removeEventListener('transitionend', h);
        if (!collapsed) content.style.maxHeight = 'none';
      }, { once: true });
      
      button.style.opacity = '0';
      setTimeout(() => {
        button.textContent = collapsed ? 'Devamını Gör' : 'Daha Az Göster';
        button.style.opacity = '1';
      }, 150);

      const desc = container.closest('.ja-productpage-collapse-item__desc');
      if (desc && desc.parentElement.classList.contains('show')) {
        const wasNone = getComputedStyle(desc).maxHeight === 'none';
        if (wasNone) { desc.style.maxHeight = desc.scrollHeight + 'px'; }
        raf2(() => setMaxHeight(desc));
        if (wasNone) { unlock(desc); }
      }
    });
    
    ro.observe(content);
    checkHeight();
    container.dataset.readMoreInitialized = 'true';
  };

  collapseRoot.querySelectorAll('[data-collapsible-container]').forEach(initReadMore);
  
  // Tabs
  function initializeProductTabs() {
    collapseRoot.querySelectorAll(".product-tabs-container").forEach(container => {
      container.querySelectorAll('.product-tab-content').forEach(content => { ro.observe(content); });

      container.querySelectorAll('.product-tab-content img, .product-tab-content iframe, .product-tab-content video')
        .forEach(el => {
          el.addEventListener('load', () => {
            const desc = container.closest('.ja-productpage-collapse-item__desc');
            if (desc && desc.parentElement.classList.contains('show')) setMaxHeight(desc);
          }, { once: false, passive: true });
        });

      container.addEventListener('click', (e) => {
        const link = e.target.closest('.product-tab-link');
        if (!link) return;

        const targetSelector = link.dataset.tabTarget;
        const targetContent = container.querySelector(targetSelector);
        
        container.querySelectorAll('.product-tab-link').forEach(l => l.classList.remove('is-active'));
        container.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('is-active'));

        link.classList.add('is-active');
        if (targetContent) targetContent.classList.add('is-active');

        const desc = container.closest('.ja-productpage-collapse-item__desc');
        if (desc && desc.parentElement.classList.contains('show')) {
          const wasNone = getComputedStyle(desc).maxHeight === 'none';
          if (wasNone) desc.style.maxHeight = desc.scrollHeight + 'px';
          raf2(() => setMaxHeight(desc));
          unlock(desc);
        }
      });
    });
  }
  initializeProductTabs();
  
  // Initial
  const openOnLoad = collapseRoot.querySelector('.ja-productpage-collapse-item.show .ja-productpage-collapse-item__desc');
  if (openOnLoad) { setMaxHeight(openOnLoad); unlock(openOnLoad); }
});
